// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.field-error {
  display: flex;
  text-transform: none;
}
.field-error-icon {
  padding-right: 5px;
  font-size: 21px;
}
.field-error-text {
  padding-top: 1px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/field-error/field-error.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/field-error/field-error.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oBAAA;ACCF;ADAE;EACE,kBAAA;EACA,eAAA;ACEJ;ADCE;EACE,gBAAA;EACA,eAAA;ACCJ","sourcesContent":[".field-error {\r\n  display: flex;\r\n  text-transform: none;\r\n  &-icon {\r\n    padding-right: 5px;\r\n    font-size: 21px;\r\n  }\r\n\r\n  &-text {\r\n    padding-top: 1px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n",".field-error {\n  display: flex;\n  text-transform: none;\n}\n.field-error-icon {\n  padding-right: 5px;\n  font-size: 21px;\n}\n.field-error-text {\n  padding-top: 1px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
